import { post, postData } from '../util/Api';
import { Assignment } from './AssignmentModel';
import { DailyReportMember } from './DailyReport/DailyReportMemberModel';

/**
 * ユーザー
 */
export interface User {
  /**管理者権限(名称が紛らわしい) */
  admin: number;
  current_company_id: number;
  email: string;
  // email_verified_at?: Date;
  id: number;
  /**最上位管理者権限(名称が紛らわしい) */
  master: number;
  name: string;
  rank: number;
  code?: string;
  destination_email?: string;
  created_at: Date;
  updated_at: Date;
  deleted_at?: Date;
  current_company?: Company;
  daily_reports_members?: DailyReportMember[];
  assignments?: Assignment;
  is_public_report?: boolean;
}

export class UserModel {
  static set(data: any): User {
    const d: User = {
      admin: data.admin,
      current_company_id: data.current_company_id,
      email: data.email,
      // email_verified_at
      id: data.id,
      master: data.master,
      name: data.name,
      rank: data.rank,
      destination_email: data.destination_email,
      created_at: data.created_at,
      updated_at: data.updated_at,
      current_company: data?.current_company,
      daily_reports_members: data?.daily_reports_members,
      assignments: data?.assignments,
      is_public_report: data?.is_public_report,
    };

    return d;
  }

  /**
   * 自分のユーザー情報を取得する
   * @returns
   */
  static async fetchMyUserInfo(): Promise<User> {
    const uri = '/user/showMyInfo';
    let response = await post(uri, {});
    return this.set(response.data);
  }

  /**
   * 会社のユーザー情報を取得する
   */
  static async fetchMyCompanyUsers(params?: { is_public_report?: boolean }): Promise<User[]> {
    const uri = '/user/listMyCompany';
    let response = await postData(uri, params);

    if (response.status !== 200) {
      throw new Error();
    }

    const responseData = response.data;
    const users = Array.isArray(responseData)
      ? responseData.map((data: any) => this.set(data))
      : [this.set(responseData.data)];

    return users;
  }
  /**
   * 全体
   */
  static async fetchAll(): Promise<User[]> {
    const uri = '/user/listAll';
    let response = await postData(uri);

    if (response.status !== 200) {
      throw new Error();
    }

    const responseData = response.data;
    const users = Array.isArray(responseData)
      ? responseData.map((data: any) => this.set(data))
      : [this.set(responseData.data)];

    return users;
  }

  /**
   * 日報の全体公開変更
   * @param params
   * @returns
   */
  static async changeIsPublicReport(params: { is_public_report: boolean }): Promise<boolean> {
    const uri = '/user/change-public-report';
    let response = await postData(uri, params);

    if (response.status !== 200) {
      throw new Error();
    }

    return response.data;
  }
}
